import React from "react"
import {Table, Button} from "react-bootstrap"
import {formatTime, formatPhone} from "./tools"

class CdrsGrouped extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data: props.data,
        }
    }

    componentDidUpdate = prevProps => {
        if (this.props.data !== prevProps.data) {
            this.setState({
                data: this.props.data,
            })
        }
    }

    onSelect = (e, did) => {
        e.preventDefault()
        this.props.onSelect(did)
    }

    render() {
        const data = this.state.data

        const total = data.reduce(
            (acc, v) => {
                return {
                    num: acc.num + v.get("num"),
                    uniq: acc.uniq + v.get("uniq"),
                    duration: acc.duration + v.get("duration"),
                }
            },
            {
                num: 0,
                duration: 0,
                uniq: 0,
            },
        )

        return (
            <Table striped>
                <thead>
                    <tr>
                        <th>DID</th>
                        <th className="right">Calls</th>
                        <th className="right">Unique Calls</th>
                        <th className="right">Duration</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.data.size === 0 && (
                        <tr>
                            <td colSpan={5}>
                                <center>No Data</center>
                            </td>
                        </tr>
                    )}
                    {this.state.data.map((item, key) => (
                        <tr key={item.get("did")}>
                            <td>{formatPhone(item.get("did"))}</td>
                            <td className="right">{item.get("num")}</td>
                            <td className="right">{item.get("uniq")}</td>
                            <td className="right" title={`${item.get("duration")} seconds`}>
                                {formatTime(item.get("duration"))}
                            </td>
                            <td className="right">
                                <Button variant="info" size="sm" onClick={e => this.onSelect(e, item.get("did"))}>
                                    View CDRs
                                </Button>
                            </td>
                        </tr>
                    ))}
                    <tr>
                        <td>TOTAL</td>
                        <td className="right">{total.num}</td>
                        <td className="right">{total.uniq}</td>
                        <td className="right" title={`${total.duration} seconds`}>
                            {formatTime(total.duration)}
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </Table>
        )
    }
}

export default CdrsGrouped
